/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b3725e9d199eda25f4ccee20a5b57efc56b69c2b";
